import Vue from 'vue';
// @todo remove after finishing integration
export default Vue.extend({
    props: {
        confirmed: {
            type: Boolean,
            required: true,
        },
        failed: {
            type: Boolean,
            required: true,
        },
    },
    methods: {
        continueClicked() {
            this.$router.push({ name: 'CheckoutConfirmation' });
        },
    },
});
